import Vue from 'vue';
import permitsImportService from '@/api/permits-import-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

const state = {
  // file: null,
  importValidationErrors: {},
  importedFilesResponse: null,
};

const mutations = {
  SET_IMPORT_VALIDATION_ERRORS(state, permitValidationErrors) {
    state.importValidationErrors = permitValidationErrors;
  },

  SET_IMPORTED_FILE_RESPONSE(state, response) {
    state.importedFilesResponse = response;
  },

  CLEAR_IMPORT_VALIDATION_ERRORS(state, field) {
    Vue.delete(state.importValidationErrors, field);
  },
};

const actions = {
  uploadFile({ commit }, payload) {
    return permitsImportService
      .upload(payload)
      .then((res) => {
        commit('SET_IMPORTED_FILE_RESPONSE', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('permits_imported'));
        return res.data;
      })
      .catch((err) => {
        commit('SET_IMPORT_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  clearImportValidationErrors({ commit }, field) {
    commit('CLEAR_IMPORT_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
